<template>
  <div>
    <b-container class="bv-example-row">
      <b-form @submit="uploadImage">
        <b-form-group id="input-group-1" label="Image name:" label-for="input-1">
          <b-form-input id="input-1" v-model="imageName" type="text" required placeholder></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="Image:" label-for="input-2">
          <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </b-form-group>

        <b-button variant="danger" @click="cancelClick">Cancel</b-button>&nbsp;
        <b-button type="submit" variant="primary">Upload</b-button>
      </b-form>
      <br />
    </b-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "AddImage",
  data() {
    return {
      imageName: "",
      file: null,
    };
  },
  methods: {
    uploadImage(e) {
      e.preventDefault();

      // IMAGE UPLOADS USING FORMS
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("name", this.imageName);
      axios
        .post(process.env.VUE_APP_API_SERVER.concat("/v1/images"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          this.$emit("uploadSuccess", response.data.data);
        })
        .catch((error) => console.log(error))
        .finally(() => (this.loading = false));
    },
    cancelClick() {
      this.$emit("cancelClick");
    },
    mounted() {},
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>